import { createGettext } from 'vue3-gettext';

export const availableLocales = [
  'en',
  'fr',
  'es',
  'de',
  'it',
];
export const defaultLanguage = 'en';

const gettext = createGettext({
  availableLanguages: {
    en: 'English',
    fr: 'Français',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
  },
  defaultLanguage,
  silent: true,
});

export default gettext;
